import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n.ts'
import App from './App.tsx'
import { installErrorCapture } from './diagnostics/reporter.ts'

// M11: uncaught errors and unhandled rejections are captured from the first moment (diagnostics/reporter.ts); they reach the server through the reporter of the
// login and club open when they happened (none open: dropped)
installErrorCapture()
createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>)
